// tslint:disable-next-line:no-submodule-imports
import * as firestore from "react-firebase-hooks/firestore"

export const useDocument = firestore.useDocument
export const useCollection = firestore.useCollection
